import { show } from 'redux-modal'
import { PROVIDE_PHONE_NUMBER_MODAL } from '.'

export const showProvidedNumberPhoneModal = (communicationPreferences, newValue) => dispatch =>
  dispatch(show(PROVIDE_PHONE_NUMBER_MODAL, { communicationPreferences, newValue }))
